import { useAtom } from "jotai";
import { businessInterestsAtom, businessInterestsWithPhotosAtom } from "../interests/atoms";
import { useQueryClient } from "@tanstack/react-query";

/**
 * Hook to access business interests data
 * @param includePhotos - Whether to include photo data (default: true for backward compatibility)
 * @returns Object with data, isLoading, error, and refetch function
 */
export function useBusinessInterests(includePhotos: boolean = true) {
  const atom = includePhotos ? businessInterestsWithPhotosAtom : businessInterestsAtom;
  const [{ data, isLoading, error }] = useAtom(atom);
  const queryClient = useQueryClient();

  // Provide a refetch function for compatibility with existing code
  const refetch = () => {
    queryClient.invalidateQueries({
      queryKey: ["businessInterests"],
      exact: false,
    });
  };

  return {
    data: data || [],
    isLoading,
    error,
    refetch,
  };
}
